module.exports = __webpack_public_path__ + "img/image 18.d4247aeb.png";